function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC107"
    },
    d: "M 40 40 L 8 40 C 7.28125 40 6.621094 39.617188 6.265625 38.996094 C 5.910156 38.375 5.910156 37.609375 6.273438 36.992188 L 22.273438 8.992188 C 22.632813 8.378906 23.289063 8 24 8 C 24.710938 8 25.367188 8.378906 25.726563 8.992188 L 41.726563 36.992188 C 42.089844 37.609375 42.089844 38.375 41.734375 38.996094 C 41.378906 39.617188 40.714844 40 40 40 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D4037"
    },
    d: "M 22 34.140625 C 22 33.871094 22.046875 33.628906 22.144531 33.394531 C 22.238281 33.167969 22.371094 32.96875 22.546875 32.804688 C 22.71875 32.636719 22.929688 32.503906 23.171875 32.410156 C 23.414063 32.320313 23.6875 32.269531 23.992188 32.269531 C 24.300781 32.269531 24.574219 32.320313 24.820313 32.410156 C 25.070313 32.503906 25.28125 32.636719 25.453125 32.804688 C 25.628906 32.96875 25.765625 33.167969 25.855469 33.394531 C 25.953125 33.628906 26 33.871094 26 34.140625 C 26 34.410156 25.953125 34.65625 25.855469 34.882813 C 25.761719 35.105469 25.628906 35.300781 25.453125 35.46875 C 25.28125 35.636719 25.070313 35.765625 24.820313 35.863281 C 24.574219 35.953125 24.300781 36 23.992188 36 C 23.6875 36 23.414063 35.953125 23.171875 35.859375 C 22.929688 35.765625 22.71875 35.636719 22.546875 35.46875 C 22.371094 35.300781 22.234375 35.105469 22.144531 34.882813 C 22.046875 34.65625 22 34.410156 22 34.140625 M 25.480469 30 L 22.507813 30 L 22.085938 18 L 25.898438 18 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.fe4fb9c9c7d1336037e334d089f72dfc.svg";
export { ForwardRef as ReactComponent };